import React from "react";
import "./NewsSlider.css";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation, Scrollbar, A11y } from "swiper";
import NewSingleNews from "../SingleNews/NewSingleNews";
import Text from "../Text/Text";
import MyButton from "../Button/Button";

// Learning From Cryptopedia Slider

const NewsSliderCarosel = (ImgWidth) => {
  const News = [
    // DynaSys Networks and HEXING Group Partner to Advance Global Smart Water Metering”
    {
      NewsLink:
        "/dynaSys-networks-and-hexing-group-partner-to-advance-global-smart-water-metering",
      NewsDate: "Thu 16 Jul, 2026",
      NewsHeading:
        "DynaSys Networks and HEXING Group Partner to Advance Global Smart Water Metering",
      NewsDetails:
        "DynaSys Networks and HEXING Group sign MoU to commercialize AI and IoT driven 170,000 smart water meters across Pakistan, Africa, and Central Asia.",
      NewsImage: "/Images/dynasys-networks-and-hexing-group.png",
    },

    // Smarter Buildings Start Here: DynaSys Networks and Milesight Unveil the “EG71 Building IoT Gateway”
    {
      NewsLink:
        "/smarter-buildings-start-here-dynaSys-networks-and-milesight-unveil-the-eg71-building-iot-gateway",
      NewsDate: "Wed 08 Apr, 2026",
      NewsHeading:
        "Smarter Buildings Start Here: DynaSys Networks and Milesight Unveil the “EG71 Building IoT Gateway”  ",
      NewsDetails:
        "DynaSys Networks, Pakistan's premier IoT solutions provider, has partnered with Milesight a globally",
      NewsImage: "/Images/smarter-buildings-start-here.png",
    },

    // A Spectacular Night in Chinese Taipei: DynaSys Networks Bags Major Awards at APICTA 2025
    {
      NewsLink:
        "/a-spectacular-night-in-chinese-taipei-dynaSys-networks-bags-major-awards-at-apicta-2025 ",
      NewsDate: "Mon 08 Dec, 2025",
      NewsHeading:
        "A Spectacular Night in Chinese Taipei: DynaSys Networks Bags Major Awards at APICTA 2025 ",
      NewsDetails:
        "JDynaSys Networks, a leading Internet of Things (IoT) network operator and solutions provider received",
      NewsImage: "/Images/a-spectacular-night-in-chinese-aipei.webp",
    },

    // Jazz & DynaSys Ignite Pakistan’s First Smart City Revolution with LoRaWAN Network Enablement
    {
      NewsLink:
        "/jazz-and-dynasys-ignite-pakistan-first-smart-city-revolution-with-lorawan-network-enablement",
      NewsDate: "Thu 23 Oct, 2025",
      NewsHeading:
        "Jazz & DynaSys Ignite Pakistan’s First Smart City Revolution with LoRaWAN Network Enablement",
      NewsDetails:
        "Jazz, Pakistan’s largest digital services provider, in partnership with DynaSys Networks, a leader in Internet of Things (IoT) solutions.",
      NewsImage: "/Images/jazz-dynasys-ignite-pakistan.webp",
    },

    // Disrupt-X, Intel, and DynaSys Networks Collaborate to Drive Digital Transformation for Critical Infrastructure ...
    {
      NewsLink:
        "/disrupt-x-intel-and-dynasys-networks-collaborate-to-drive-digital-transformation-for-critical-infrastructure",
      NewsDate: "Tue 21 Oct, 2025",
      NewsHeading:
        "Disrupt-X, Intel, and DynaSys Networks Collaborate to Drive Digital Transformation for Critical Infrastructure",
      NewsDetails:
        "Joint initiative explores AI-enabled climate resilience, smart utilities, and sustainable infrastructure at national scale.",
      NewsImage: "/Images/disrupt-dynasys-collaborate.webp",
    },

    // DynaSys and Plan-S Partner to Bring Satellite-Powered IoT to Every Corner
    {
      NewsLink: "/dynasys_plan_s_partner_to_bring_satellite_powered",
      NewsDate: "Wed 15 Oct, 2025",
      NewsHeading:
        "DynaSys and Plan-S To Connect Earth’s Most Remote Areas via Satellite IoT ",
      NewsDetails:
        "DynaSys Networks, a leader in Internet of Things (IoT) solutions, and Plan-S, Türkiye’s pioneering space technology company...",
      NewsImage: "/Images/dynasys-and-plan-s-partner.webp",
    },

    // Disrupt-X and DynaSys Join Hands to Develop Infrastructure in Pakistan to Support 40 Million Smart Water Meters
    {
      NewsLink: "/disrupt_x_and_dynasys_join_hands",
      NewsDate: "Thu 09 Oct, 2025",
      NewsHeading:
        "Disrupt-X and DynaSys Join Hands to Develop Infrastructure in Pakistan to Support 40 Million Smart Water Meters",
      NewsDetails:
        "Disrupt-X and DynaSys Networks (“DynaSys”) have announced a landmark initiative to enhance ALEF, the unified IoT platform and communications...",
      NewsImage: "/Images/disrupt-x-and- dynasys-join hands.webp",
    },

    // DynaSys Networks Bags 4 Awards at HBL P@SHA ICT Awards 2025
    {
      NewsLink: "/dynasys_networks_awards_hbl_pasha_awards_2025",
      NewsDate: "Fri 19 Sep, 2025",
      NewsHeading:
        "DynaSys Networks Bags 4 Awards at HBL P@SHA ICT Awards 2025",
      NewsDetails:
        "The spotlight at HBL P@SHA ICT Awards 2025 was on DynaSys Networks, which walked away with an impressive four (04) awards, making it the most decorated...",
      NewsImage: "/Images/dynasys-pasha-2025.webp",
      // NewsImageMob: "/Images/Muhammad_Uzair_Akhtar_mobile.webp",
    },

    // NADRA Technologies Joins Forces with DynaSys to Accelerate IoT Adoption in Pakistan
    {
      NewsLink: "/nadra_technologies_joins_forces_with_dynasys",
      NewsDate: "Sat 13 Sep, 2025",
      NewsHeading:
        "NADRA Technologies Joins Forces with DynaSys to Accelerate IoT Adoption in Pakistan",
      NewsDetails:
        "NADRA Technologies Limited (NTL), Pakistan's National Database and Registration Authority's (NADRA) commercial division, and DynaSys Networks...",
      NewsImage: "/Images/nadra-technologies-joins-forces.webp",
      // NewsImageMob: "/Images/Muhammad_Uzair_Akhtar_mobile.webp",
    },

    //DynaSys and Jazz Launch First City-Wide LoRaWAN Network in Lahore, Pioneering Pakistan Digital Future
    // {
    //   NewsLink: "/dynaSys_jazz_launch_first_city_wide_lorawan_network",
    //   NewsDate: "Mon 01 Sep, 2025",
    //   NewsHeading:
    //     "DynaSys and Jazz Launch First City-Wide LoRaWAN Network in Lahore, Pioneering Pakistan's Digital Future",
    //   NewsDetails:
    //     "In a landmark move for Pakistan&#39;s digital landscape, DynaSys Networks, a leader in Internet of Things (IoT) solutions,",
    //   NewsImage: "/Images/WeatherWalay_DynaSys_Networks_Partner.webp",
    //   NewsImageMob: "/Images/WeatherWalay_DynaSys_Networks_Partner.webp",
    // },

    // WeatherWalay and DynaSys Networks Partner to Leverage IoT for Climate Monitoring and Disaster Management
    {
      NewsLink:
        "/muhammad_uzair_akhtar_appointed_head_of_products_iot_at_dynasys_networks",
      NewsDate: "Sat 30 Aug, 2025",
      NewsHeading:
        "Muhammad Uzair Akhtar Appointed as Head of Products – IoT at DynaSys Networks",
      NewsDetails:
        "DynaSys Networks announced today that Muhammad Uzair Akhtar has been appointed as the Head of Products - IoT.",
      NewsImage: "/Images/Muhammad_Uzair_Akhtar_mobile.webp",
      // NewsImageMob: "/Images/Muhammad_Uzair_Akhtar_mobile.webp",
    },

    // WeatherWalay and DynaSys Networks Partner to Leverage IoT for Climate Monitoring and Disaster Management
    {
      NewsLink:
        "/weatherwalay_and_dynasys_networks_partner_to_leverage_iot_for_climate",
      NewsDate: "Fri 08 Aug, 2025",
      NewsHeading:
        "WeatherWalay and DynaSys Networks Partner to Leverage IoT for Climate Monitoring and Disaster Management",
      NewsDetails:
        "WeatherWalay and DynaSys Networks Partner to Leverage IoT for Climate Monitoring and Disaster Management",
      NewsImage: "/Images/WeatherWalay_DynaSys_Networks_Partner.webp",
      // NewsImageMob: "/Images/WeatherWalay_DynaSys_Networks_Partner.webp",
    },

    // DynaSys Networks Signs Strategic MoU with APPLIOT GLOBAL to Accelerate Global IoT Expansion
    {
      NewsLink: "/dynaSys_networks_signs_strategic_mou",
      NewsDate: "Thu 26 June, 2025",
      NewsHeading:
        "DynaSys Networks Signs Strategic MoU with APPLIOT GLOBAL to Accelerate Global IoT Expansion",
      NewsDetails:
        "DynaSys Networks Signs Strategic MoU with APPLIOT GLOBAL to Accelerate Global IoT Expansion",
      NewsImage: "/Images/DynaSys NetworksSignsStrategicMoUMobileImage.png",
      NewsImageMob: "/Images/DynaSys NetworksSignsStrategicMoUMobileImage.png",
    },

    // A Major IoT Partnership Emerges in Pakistan
    {
      NewsLink: "/pakistan_milesight_and_dynaSys_networks_join_hands",
      NewsDate: "Thu 19 June, 2025",
      NewsHeading:
        "Milesight and DynaSys Networks Join Hands to Drive IoT Innovation",
      NewsDetails:
        "Milesight, a global leader in cutting-edge IoT hardware and AI-driven solutions",
      NewsImage:
        "/Images/Pakistan_Milesight_and_DynaSys_Networks _join Hands.png",
      NewsImageMob:
        "/Images/Pakistan_Milesight_and_DynaSys_Networks _join Hands.png",
    },

    // Jazz Partners with DynaSys to Accelerate IoT-Driven Innovation in Pakistan
    {
      NewsLink:
        "/jazz_partners_with_dynaSys_to_accelerate_iot_Driven_innovation_in_pakistan",
      NewsDate: "Mon 12 May, 2025",
      NewsHeading:
        "Jazz Partners with DynaSys to Accelerate IoT-Driven Innovation in Pakistan",
      NewsDetails:
        "Jazz Partners with DynaSys to Accelerate IoT-Driven Innovation in Pakistan",
      NewsImage: "/Images/jazzPartnersPressWrapperImageMobile.png",
      NewsImageMob: "/Images/jazzPartnersPressWrapperImageMobile.png",
    },

    // Azercosmos Activates First IoT Solution on Azerspace- 1 in Partnership with DynaSys Networks
    {
      NewsLink: "/azercosmos_activates_first_iot_solution",
      NewsDate: "Wed 19 March, 2025",
      NewsHeading:
        "Azercosmos Activates First IoT Solution on Azerspace- 1 in Partnership with DynaSys Networks",
      NewsDetails:
        "Azercosmos Activates First IoT Solution on Azerspace- 1 in Partnership with DynaSys Networks",
      NewsImage: "/Images/Azercosmos Activates_press_wrapper_Mobile.webp",
      NewsImageMob: "/Images/Azercosmos Activates_press_wrapper_Mobile.webp",
    },

    // DynaSys Networks Recognized for its Innovation in IoT at APICTA Awards 2024
    {
      NewsLink: "/aamir_bashir_joins_dynasys",
      NewsDate: "Tue 10 Dec, 2024",
      NewsHeading:
        "M. Aamir Bashir Joins DynaSys Networks as Head of BU - Systems Integration",
      NewsDetails:
        "With over 26 years of Telecoms and ICT experience in Defense, M. Aamir Bashir adds to the strategic",
      NewsImage: "/Images/Aamir-Bashir-Joins_press_wrapper_mobile.webp",
    },

    // DynaSys Networks Recognized for its Innovation in IoT at APICTA Awards 2024
    {
      NewsLink: "/dynasys_networks_at_apicta_awards",
      NewsDate: "Sat 7 Dec, 2024",
      NewsHeading:
        "DynaSys Networks Recognized for its Innovation in IoT at APICTA Awards 2024",
      NewsDetails: "DynaSys Networks, a leading innovator...",
      NewsImage: "/Images/Dynasys_Apicta_Image_press_wrapper_mobile.webp",
    },
    // DynaSys Networks and PakSat International Pioneer..
    {
      NewsLink: "/dynasys_networks_and_paksat_international_pioneer",
      NewsDate: "Fri 29 Nov, 2024",
      NewsHeading:
        "DynaSys Networks and PakSat International Pioneer IoT over Satellite Networks in Pakistan",
      NewsDetails: "PakSat International, Pakistan’s nationaly...",
      NewsImage:
        "/Images/DynaSys_PakSat_International_Pioneer_press_wrapper_mobile.webp",
    },
    // DynaSys Networks Pioneers Pakistan's IoT Future
    {
      NewsLink: "/dynasys_networks_pioneers_pakistan's_iot_future",
      NewsDate: "Tue 19 Nov, 2024",
      NewsHeading:
        "DynaSys Networks Pioneers Pakistan's IoT Future: The Country’s First Commercial IoT LoRaWAN Network Goes Live",
      NewsDetails: "DynaSys Networks, a leading innovator in...",
      NewsImage: "/Images/DynasysNetworkPioneerPressWrapper_mobile.webp",
    },
  ];
  return (
    <Swiper
      className=" News_Slider"
      modules={[Navigation, Scrollbar, A11y]}
      spaceBetween={0}
      slidesPerView={1}
      // scrollbar={{
      //   draggable: true,
      //   hide: false,
      //   snapOnRelease: true,
      // }}
      navigation
      breakpoints={{
        // Responsive breakpoints
        150: {
          slidesPerView: 1, // Number of slides to show on mobile
          spaceBetween: 10, // Space between slides on mobile
        },
        550: {
          slidesPerView: 1, // Number of slides to show on mobile
          spaceBetween: 20, // Space between slides on mobile
        },
        992: {
          slidesPerView: 1, // Number of slides to show on mobile
          spaceBetween: 10, // Space between slides on mobile
        },
        1351: {
          slidesPerView: 1, // Number of slides to show on mobile
          spaceBetween: 10, // Space between slides on mobile
        },
      }}
      pagination={{
        spaceBetween: 0,
      }}
      onSlideChange={() => console.log("slide change")}
      onSwiper={(swiper) => console.log(swiper)}
    >
      {/* IoT Innovation in Pakistan Accelerated – DynaSys and Pronet ink MoU */}

      {News.map((item) => (
        <SwiperSlide>
          <NewSingleNews
            newslink={item.NewsLink}
            newsdate={item.NewsDate}
            newshead={item.NewsHeading}
            newsdetails={item.NewsDetails}
            newsimage={item.NewsImage}
            newsimageMob={item.NewsImageMob}
            ImgWidth={"218px"}
            // Width={"50%"}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default function NewLandingNewsSlider() {
  return (
    <div className="NewNewsSlider">
      <MyButton
        text="Our News"
        RouteLink="/our_news"
        FontSize="2.3rem"
        FontWeight="800"
        Color="black"
        Margin="0px 0px 20px 0px"
      />

      <NewsSliderCarosel />
    </div>
  );
}
